import { graphql, useStaticQuery } from 'gatsby';

import { INavPrimaryItems } from '../utils/declarations';

interface INavPrimary {
  site: {
    siteMetadata: {
      navPrimary: INavPrimaryItems[];
    };
  };
}

const useNavPrimary = () => {
  const { site }: INavPrimary = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            navPrimary {
              title
              slug
              children
              childSortOrder
            }
          }
        }
      }
    `,
  );

  return site.siteMetadata.navPrimary;
};

export default useNavPrimary;
